// 403, 404, Absturz und „wird gebaut“ – gleiche Optik über die Zustand-Komponente.
import { CircleAlert, Construction, FileQuestion, Lock } from "lucide-react";
import { Link, isRouteErrorResponse, useRouteError } from "react-router";
import { Zustand } from "../bausteine/einfach";
import type { Seite } from "../navigation/katalog";

export function NichtGefunden() {
  return (
    <div className="im-karte">
      <Zustand symbol={FileQuestion} titel="Diese Seite gibt es nicht"
        aktion={<Link className="im-link" to="/">Zum Start</Link>}>
        Die Adresse ist veraltet oder falsch geschrieben. Mit ⌘K findest du jede Seite.
      </Zustand>
    </div>
  );
}

export function KeinZugriff({ rechte }: { rechte: readonly string[] }) {
  return (
    <div className="im-karte">
      <Zustand symbol={Lock} titel="Dafür fehlt dir die Freigabe">
        Benötigt: <span className="im-code">{rechte.join(" oder ")}</span>. Freigaben vergibt die Verwaltung.
      </Zustand>
    </div>
  );
}

export function Geplant({ seite }: { seite: Seite }) {
  return (
    <div className="im-karte">
      <Zustand symbol={Construction} titel={`${seite.titel} wird in Welle ${seite.welle} gebaut`}>
        {seite.beschreibung} Bis dahin läuft diese Funktion im bisherigen IMHO.
      </Zustand>
    </div>
  );
}

export function Absturz() {
  const fehler = useRouteError();
  const text = isRouteErrorResponse(fehler) ? `${fehler.status} ${fehler.statusText}`
    : fehler instanceof Error ? fehler.message : String(fehler);
  return (
    <div className="im-root im-absturz">
      <Zustand symbol={CircleAlert} titel="Diese Ansicht ist abgestürzt"
        aktion={<button type="button" className="im-btn" onClick={() => window.location.reload()}>Neu laden</button>}>
        <span className="im-code">{text}</span>
      </Zustand>
    </div>
  );
}
